// extracted by mini-css-extract-plugin
export default {"stepSubTitle":"ui_stepSubTitle__c20mM","stepTitle":"ui_stepTitle__eJOOj","content":"content ui_content__rQ2NP","ant-typography":"ant-typography","antTypography":"ant-typography"};